import { Theme } from "@mui/material";

import defaultTheme from "../themes/default";
import blackOnYellowTheme from "../themes/blackOnYellow";
import yellowOnBlackTheme from "../themes/yellowOnBlack";
import whiteOnBlackTheme from "../themes/whiteOnBlack";

export enum THEMES {
    default = "default",
    blackOnYellow = "blackOnYellow",
    yellowOnBlack = "yellowOnBlack",
    whiteOnBlack = "whiteOnBlack",
}

export interface ITheme {
    theme: Theme;
}

type IThemesList = {
    [key in THEMES]: ITheme;
};

export const THEMES_LIST: IThemesList = {
    [THEMES.default]: {
        theme: defaultTheme,
    },
    [THEMES.whiteOnBlack]: {
        theme: whiteOnBlackTheme,
    },
    [THEMES.blackOnYellow]: {
        theme: blackOnYellowTheme,
    },
    [THEMES.yellowOnBlack]: {
        theme: yellowOnBlackTheme,
    },
};
